
export class CountryBasedFirebaseInitialize {
    app: firebase.app.App
    remoteConfig: firebase.remoteConfig.RemoteConfig
    initialize: Function
}